import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb, Button, Layout, theme } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import SidebarMenu from '../components/common/SidebarMenu';
import { AppRoutes } from '../routes';
import { useAuth } from '../contexts/AuthContext';
import './MainLayout.css';

const { Content, Footer, Sider } = Layout;

const getBreadcrumbs = (pathname: string) => {
  if (pathname.includes("/property-sale-histories/details/"))
    return [
      { title: "物件一覧", path: "/property-sale-histories" },
      { title: pathname.split("/").at(-1) },
    ];

  if (pathname.includes("/notification-properties/new"))
    return [
      { title: "通知物件一覧", path: "/notification-properties" },
      { title: "新規登録" },
    ];

  if (pathname.includes("/notification-properties/edit/"))
    return [
      { title: "通知物件一覧", path: "/notification-properties" },
      { title: "編集" },
    ];

  const breadcrumbMap: Record<string, { title: string; path?: string }[]> = {
    "/property-sale-histories": [
      { title: "物件一覧" },
    ],
    "/notification-properties": [
      { title: "通知物件一覧" },
    ],
    "/simulation": [
      { title: "シミュレーション" },
    ],
  };

  return breadcrumbMap[pathname] || [{ title: "トランコン・ザック・ディン" }];
};

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const breadcrumbItems = getBreadcrumbs(location.pathname);

  // ログインページの場合はサイドバーなしでルーティングのみ表示
  if (location.pathname === '/login' || !isAuthenticated) {
    return <AppRoutes />;
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "transparent" }} className="dark-theme-container">
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={260}
        style={{
          background: "#FAFAFA",
          borderRight: "1px solid #E5E7EB",
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <SidebarMenu collapsed={collapsed} />
          <div style={{
            marginTop: 'auto',
            padding: '8px 16px',
            borderTop: '1px solid #E5E7EB',
          }}>
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={logout}
              style={{ color: '#9CA3AF', width: '100%', textAlign: 'left' }}
            >
              {!collapsed && 'ログアウト'}
            </Button>
          </div>
        </div>
      </Sider>

      <Layout style={{ background: "transparent" }}>

        <Content style={{ margin: "24px 15px 0" }}>
          <Breadcrumb
            className="dark-breadcrumb"
            style={{ margin: "0 0 24px 0" }}
            items={breadcrumbItems.map((item, idx) => {
              const isLast = idx === breadcrumbItems.length - 1;
              if (item.path && !isLast) {
                return {
                  title: (
                    <Link to={item.path} style={{ color: '#9CA3AF' }}>{item.title}</Link>
                  )
                };
              }
              return { title: item.title };
            })}
          />

          <div
            style={{
              paddingBottom: 15,
              minHeight: "calc(100vh - 200px)",
              background: "transparent",
            }}
          >
            <AppRoutes />
          </div>
        </Content>

        <Footer style={{
          height: 48,
          textAlign: "center",
          background: "#FAFAFA",
          color: "#9CA3AF",
          borderTop: "1px solid #E5E7EB",
          padding: "10px 50px",
        }}>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
